import { parseDashManifest } from './dash-manifest-parser';
import { getHlsManifest } from './hls-manifest-fetcher';
import { CHUNK_TEMPLATE } from './manifest.const';
export class ManifestManager {
    constructor(_httpClient) {
        this._httpClient = _httpClient;
        this._currentRepresentationIndex = {
            video: 0,
            audio: 0
        };
    }
    async init_m(manifestUrl) {
        this._manifestUrl = manifestUrl;
        try {
            if (manifestUrl.endsWith('.mpd')) {
                const manifestResponse = await this._httpClient.fetchText_m(manifestUrl);
                this._manifest = parseDashManifest(manifestResponse);
                console.debug('[ManifestManager] dash manifest parsed', this._manifest);
            }
            else if (manifestUrl.endsWith('.m3u8')) {
                this._manifest = await getHlsManifest(this._httpClient, manifestUrl);
                console.debug('[ManifestManager] hls manifest parsed', this._manifest);
            }
            else {
                throw new Error(`Unsupported streaming manifest: ${manifestUrl}`);
            }
            this.setHighestVideoQuality_m();
        }
        catch (error) {
            console.error('Error fetching and parsing manifest', error);
        }
    }
    setHighestVideoQuality_m() {
        this._currentRepresentationIndex.video = this._manifest.representations.video.length - 1;
    }
    getCodecs_m(type) {
        return this._manifest.codecs[type];
    }
    getTotalDuration_m() {
        return this._manifest.totalDuration;
    }
    getTotalChunks_m() {
        return this._manifest.totalChunks;
    }
    /**
     * Returns the base URL inferred from the manifest's location.
     * http://blob.storage.net/123/guid.mpd -> http://blob.storage.net/123
     * @private
     */
    getBaseUrl_m() {
        return this._manifestUrl.substring(0, this._manifestUrl.lastIndexOf('/'));
    }
    getInitUrl_m(baseUrl, type) {
        const { initUrl } = this.getCurrentRepresentation_m(type);
        return `${baseUrl}/${initUrl}`;
    }
    getChunkUrl_m(baseUrl, chunkIndex, type) {
        const chunkUrl = this.getNextChunkUrl_m(chunkIndex, type);
        return `${baseUrl}/${chunkUrl}`;
    }
    getNextChunkUrl_m(chunkIndex, type) {
        if (chunkIndex >= this.getTotalChunks_m()) {
            throw new Error('Chunk index cannot be greater or equal than the total number of chunks.');
        }
        const { chunkUrlTemplate, startIndex } = this.getCurrentRepresentation_m(type);
        return chunkUrlTemplate.replace(CHUNK_TEMPLATE, (chunkIndex + startIndex).toString());
    }
    getManifest_m() {
        return this._manifest;
    }
    getCurrentRepresentation_m(type) {
        const manifest = this.getManifest_m();
        return manifest.representations[type][this._currentRepresentationIndex[type]];
    }
    verifyCurrentRepresentation_m(bps, type) {
        const previousIndex = this._currentRepresentationIndex[type];
        this._currentRepresentationIndex[type] = 0; // reset to the lowest bitrate
        // find a representation that matches our current bandwidth, starting at the best one
        const representations = this.getManifest_m().representations[type];
        for (let i = representations.length - 1; i > 0; i--) {
            if (bps > representations[i].bandwidth) {
                this._currentRepresentationIndex[type] = i;
                break;
            }
        }
        if (previousIndex !== this._currentRepresentationIndex[type]) {
            console.log(`Switching to representation[${this.getCurrentRepresentation_m(type).name}]`);
        }
    }
}
